import app from '../app';
import Hero from './Hero';
import Button from '../../common/components/Button';
import ItemList from '../../common/utils/ItemList';
const LOCAL_STORAGE_KEY = 'welcomeHidden';

/**
 * The `WelcomeHero` component displays a hero that welcomes the user to the
 * forum.
 */
export default class WelcomeHero extends Hero {
  className() {
    return 'WelcomeHero';
  }
  view() {
    if (this.isHidden()) return null;
    return super.view();
  }
  bodyItems() {
    const items = new ItemList();
    const slideUp = () => {
      this.$().slideUp(this.hide.bind(this));
    };
    items.add('dismiss-button', m(Button, {
      icon: "fas fa-times",
      onclick: slideUp,
      className: "Hero-close Button Button--icon Button--link",
      "aria-label": app.translator.trans('core.forum.welcome_hero.hide')
    }), 100);
    items.add('content', m("div", {
      className: "containerNarrow"
    }, this.contentItems().toArray()), 80);
    return items;
  }
  contentItems() {
    const items = new ItemList();
    items.add('title', m("h1", {
      className: "Hero-title"
    }, app.forum.attribute('welcomeTitle')), 100);
    items.add('subtitle', m("div", {
      className: "Hero-subtitle"
    }, m.trust(app.forum.attribute('welcomeMessage'))));
    return items;
  }

  /**
   * Hide the welcome hero.
   */
  hide() {
    localStorage.setItem(LOCAL_STORAGE_KEY, 'true');
  }

  /**
   * Determines whether the welcome hero should be hidden.
   *
   * @returns if the welcome hero is hidden.
   */
  isHidden() {
    if (!app.forum.attribute('welcomeTitle')?.trim()) return true;
    if (localStorage.getItem(LOCAL_STORAGE_KEY)) return true;
    return false;
  }
}
flarum.reg.add('core', 'forum/components/WelcomeHero', WelcomeHero);